import React from "react";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Routes from './Routes';

function App() {
  return (
    <BrowserRouter basename="/foodloop">
      <AuthProvider>
        <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50">
          <Routes />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;